// extracted by mini-css-extract-plugin
export default {"icon":"AddButton_icon__j3d45"};